import { LookupAccountContext } from '@chargeafter/payment-types';

import { logger } from '../../logger';
import { paymentsPresent } from '../present/payments/paymentsPresent';
import { printInitError } from '../printInitError/printInitError';
import { store } from '../store';

const filename = 'lookupAccount';

export const lookupAccount = async (
  sessionToken: string,
  context: LookupAccountContext
) => {
  if (!store.isInitialized) return printInitError('lookupAccount', filename);

  logger.linkId = store.config?.linkId;

  logger.log(`about to present LookupAccount`, {
    function: 'lookupAccount',
    filename,
    context,
  });

  return paymentsPresent('lookupAccount', {
    ...context,
    sessionToken,
  });
};
